import ApiManager from '../../utils/ApiManager'
import Constants from '../../utils/Constants'

const state = {
  message: {
    content: '',
    type: ''
  }
}

const actions = {
  getInitData ({ dispatch, state, commit }) {
    commit('init')
  },
  async sendMail ({ state, commit }, user) {
    this.dispatch('loading/loadingPagePlus')
    const response = await ApiManager.request('Password').passwordSend(user)
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
    return { content: response.data.data.message, type: type }
  }
}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
  },
  setMessage (state, data) {
    state.message = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
